import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AttributeValue } from '../../../../../models/section-definition.model';
import { ImageService } from '../../../../../services/image.service';

@Component({
  selector: 'lib-attribute-image-row',
  standalone: false,
  templateUrl: './attribute-image-row.component.html',
  styleUrls: ['./attribute-image-row.component.scss'],
})
export class AttributeImageRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Output() mapClicked = new EventEmitter<AttributeValue>();
  imageId!: string;
  currentRotation: number = 0;
  imgZoomFullContainer: any;
  imgElement: any;
  constructor(private renderer: Renderer2, private imageService: ImageService) {}

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
    this.getImageAddress();
  }

  getImageAddress() {
    const value = this.attributeValue;
    if (!value?.latitude || !value?.longitude || value.physicalAddress) return;

    this.imageService
      .getAddress({ latitude: value.latitude, longitude: value.longitude })
      .subscribe((data) => {
        if (data.body?.status === 'OK') {
          value.physicalAddress = data.body.data;
        }
      });
  }

  onMapClick() {
    this.mapClicked.emit(this.attributeValue);
  }
  ngOnInit(): void {
    this.imageId = this.generateId();
  }
  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      let displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  generateId(): string {
    return crypto.randomUUID();
  }
}
